import React from "react";
import PropTypes from "prop-types";
import cname from "../../style.module.scss";
import { INFO_TAB_TYPES } from "../../Spectrophotometer.utils";
import { HowItWorkImage } from "../../SpectrophotometerImages";
import { ContentParts } from "../ContentParts";

export function Content(props) {
  if (props.type === INFO_TAB_TYPES.PARTS) {
    return <ContentParts />;
  } else {
    return <HowItWorksContent />;
  }
}

Content.propTypes = {
  /**
   * Type of curent Tab
   */
  type: PropTypes.oneOf(["Parts", "How it works"]),
};

Content.defaultProp = {
  type: INFO_TAB_TYPES.PARTS,
};

function HowItWorksContent() {
  return (
    <div className={cname.content_how}>
      <div className={cname.content_how_left}>
        <p>
          Spectrophotometry is used to determine the pH of a solution by
          measuring its pH indicator absorbance. To measure the absorbance of a
          BTB sample, the cuvette with the solution is placed inside the
          spectrophotometer chamber. When orange light (at 615 nm) passes
          through the solution in the cuvette, it is absorbed by deprotonated
          BTB molecules (at higher pH). Protonated BTB (at lower pH) does not
          absorb orange light. Light that is not absorbed is transmitted and
          measured by a detector. BTB absorbance is an indirect measure of the
          pH: the higher the absorbance of a BTB solution, the higher its pH.
        </p>
        <p>
          To determine the pH of the sample quantitatively, the absorbance value
          of the unknown sample is compared to a pH standard curve that relates
          absorbance to samples of known pH.
        </p>
      </div>
      <div className={cname.content_how_right}>
        <HowItWorkImage />
      </div>
    </div>
  );
}
